var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner mx-auto",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("상품권 교환소")]), _c('div', {
    staticClass: "mt-4px mt-lg-8px font-size-14 font-size-md-16 grey--text text--garken-3"
  }, [_vm._v(" 교환권번호를 입력하여 나누리 캐시로 교환하실 수 있습니다. ")])]), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-sheet', {
    attrs: {
      "width": "100%",
      "max-width": "720"
    }
  }, [_vm.mode == 'form' || !_vm.$vuetify.breakpoint.mobile ? [_c('exchange-codes', _vm._b({
    model: {
      value: _vm.form.exchanges,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "exchanges", $$v);
      },
      expression: "form.exchanges"
    }
  }, 'exchange-codes', {
    mode: _vm.mode,
    code: _vm.code,
    loading: _vm.loading
  }, false))] : _vm._e(), _vm.mode == 'form' ? [_c('exchange-items', _vm._b({
    staticClass: "mt-10",
    model: {
      value: _vm.form.exchanges,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "exchanges", $$v);
      },
      expression: "form.exchanges"
    }
  }, 'exchange-items', {
    code: _vm.code
  }, false)), _c('div', {
    staticClass: "py-20px py-md-40px"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": _vm.$vuetify.breakpoint.mobile ? '6' : 'auto'
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "white--text w-lg-160px",
    attrs: {
      "rounded": "",
      "large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    disabled: _vm.disabled_save
  }, false), [_c('span', [_vm._v(" 상품권 교환하기 ")])])], 1), _c('v-col', {
    attrs: {
      "cols": _vm.$vuetify.breakpoint.mobile ? '6' : 'auto'
    }
  }, [_c('v-btn', {
    staticClass: "w-lg-160px border-3",
    attrs: {
      "rounded": "",
      "large": "",
      "outlined": "",
      "block": "",
      "color": "primary",
      "to": "/mypage/exchange"
    }
  }, [_c('span', {
    staticClass: "black--text"
  }, [_vm._v(" 교환내역 조회 ")])])], 1)], 1)], 1)] : _vm._e(), _vm.mode == 'view' ? [_c('exchange-table', {
    staticClass: "mt-10",
    model: {
      value: _vm.form.exchanges,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "exchanges", $$v);
      },
      expression: "form.exchanges"
    }
  }), _c('div', {
    staticClass: "py-20px py-md-40px"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": _vm.$vuetify.breakpoint.mobile ? '6' : 'auto'
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "white--text w-lg-160px",
    attrs: {
      "rounded": "",
      "large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.execCash
    }
  }, 'v-btn', {
    disabled: _vm.disabled_exec
  }, false), [_c('span', [_vm._v(" 바로 충전하기 ")])])], 1), _c('v-col', {
    attrs: {
      "cols": _vm.$vuetify.breakpoint.mobile ? '6' : 'auto'
    }
  }, [_c('exchange-gifts', _vm._g(_vm._b({
    ref: "exchange-gifts",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "w-lg-160px border-3",
          attrs: {
            "rounded": "",
            "large": "",
            "outlined": "",
            "block": "",
            "color": "primary"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          disabled: _vm.disabled_exec
        }), false), on), [_c('span', {
          staticClass: "black--text"
        }, [_vm._v(" 선물하기 ")])])];
      }
    }], null, false, 4232678377)
  }, 'exchange-gifts', {
    amount: _vm.amount
  }, false), {
    exec: _vm.execGift
  }))], 1)], 1)], 1)] : _vm._e()], 2)], 1), _vm.mode == 'form' ? [_c('v-divider', {
    staticClass: "my-20px my-lg-40px"
  }), _c('exchange-excel', _vm._b({
    model: {
      value: _vm.form.exchanges,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "exchanges", $$v);
      },
      expression: "form.exchanges"
    }
  }, 'exchange-excel', {
    code: _vm.code
  }, false))] : _vm._e(), _c('v-divider', {
    staticClass: "my-20px my-lg-40px"
  }), _c('exchange-alert')], 2)])]), _c('common-loader', _vm._b({}, 'common-loader', {
    loading: _vm.loading
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }